import axios from "axios";
const base = localStorage.getItem("baseUrl");
// export const baseUrl = "http://192.168.222.209:13003";
//  export const baseUrl = base ? base : "https://apiadmin.tmplfitness.ru/"; //прод
// export const baseUrl = base ? base : "http://31.130.151.115:8080/"; //тест
 export const baseUrl = "https://testapiadmin.tmplfitness.ru/"; //тест

axios.defaults.baseURL = baseUrl;
/* The line `// export const baseUrl = base ? base : "http://83.220.173.243:13005"; //прод` is a
commented-out line of code that seems to be setting the `baseUrl` variable based on the value
retrieved from the `localStorage` item named "baseUrl". */

const ax = axios.create();

let isRefreshing = false;
let failedQueue = []; 

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const handleLogout = () => {
  localStorage.clear();
  window.location.href = "/login";
};

// Функция для задержки между retry
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

ax.interceptors.request.use(async (config) => {
  const token = localStorage.getItem("accessToken");

  config.headers = {
    ...config.headers,
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };

  return config;
});

ax.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Настройки retry
    const retryConfig = {
      maxRetries: 5, // Максимальное количество попыток
      retryDelay: 1000, // Задержка между попытками (мс)
      retryCondition: (error) => {
        // Retry только для сетевых ошибок или 5xx ошибок сервера
        return (
          !error.response ||
          (error.response.status >= 500 && error.response.status < 600)
        );
      },
    };

    // Retry логика для сетевых ошибок и ошибок сервера
    if (!originalRequest._retryCount) {
      originalRequest._retryCount = 0;
    }

    if (
      originalRequest._retryCount < retryConfig.maxRetries &&
      retryConfig.retryCondition(error)
    ) {
      originalRequest._retryCount += 1;
      await delay(retryConfig.retryDelay * originalRequest._retryCount);
      return ax(originalRequest);
    }

    // Логика обновления токена для 401 ошибок
    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retryAuth &&
      !originalRequest.skipAuthRefresh
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(() => {
            const token = localStorage.getItem("accessToken");
            if (token) {
              originalRequest.headers.Authorization = `Bearer ${token}`;
            }
            return ax(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retryAuth = true;
      isRefreshing = true;

      try {
        const refreshToken = localStorage.getItem("accessTokenRefresh");

        if (!refreshToken) {
          throw new Error("No refresh token available");
        }

        // Запрос на обновление токена
        const response = await axios.get(`${baseUrl}api/account/refreshToken`, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${refreshToken}`,
          },
        });

        const { accessToken, refreshToken: newRefreshToken } = response.data;

        if (!accessToken) {
          throw new Error("No access token received");
        }

        // Сохраняем токены
        localStorage.setItem("accessToken", accessToken);
        if (newRefreshToken) {
          localStorage.setItem("accessTokenRefresh", newRefreshToken);
        }

        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        processQueue(null, accessToken);

        return ax(originalRequest);
      } catch (refreshError) {
        // Ошибка обновления токена - выходим
        handleLogout();
        processQueue(refreshError, null);
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    // Если это не 401 и не ошибка сети/сервера, просто пробрасываем ошибку
    return Promise.reject(error);
  },
);

export default ax;
